export default () => ({
	status: 'closed',
	navigation: []
})
